import { createAsyncThunk } from '@reduxjs/toolkit';
import { regionControlService } from './RegionControl.service';
import { errorHandlerThunk } from '../../App/App.thunk';
import { CreateRegionDto, UpdateRegionDto } from './RegionControl.type';

const THUNK_PREFIX = 'regionControl';

export const getRegionControlListThunk = createAsyncThunk(
  `${THUNK_PREFIX}/getRegionControlListThunk`,
  async (params: { q?: string; page?: number | string; sort?: string }, thunkAPI) => {
    try {
      const response = await regionControlService.getList(params);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const createRegionControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/createRegionControlThunk`,
  async (region: CreateRegionDto, thunkAPI) => {
    try {
      const response = await regionControlService.create(region);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
);

export const updateRegionControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/updateRegionControlThunk`,
  async (region: UpdateRegionDto, thunkAPI) => {
    try {
      const response = await regionControlService.update(region);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const deleteRegionControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/deleteRegionControlThunk`,
  async (id: number, thunkAPI) => {
    try {
      await regionControlService.delete(id);
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);
